import { createContext, useContext, useState, type ReactNode } from 'react'

interface MultilingualFormContextType {
  activeLanguage: string
  setActiveLanguage: (language: string) => void
}

const MultilingualFormContext = createContext<MultilingualFormContextType | undefined>(undefined)

interface MultilingualFormProviderProps {
  children: ReactNode
  defaultLanguage?: string
}

export function MultilingualFormProvider({ 
  children, 
  defaultLanguage = 'en' 
}: MultilingualFormProviderProps) {
  const [activeLanguage, setActiveLanguage] = useState(defaultLanguage)

  return (
    <MultilingualFormContext.Provider value={{ activeLanguage, setActiveLanguage }}>
      {children}
    </MultilingualFormContext.Provider>
  )
}

export function useMultilingualForm() {
  const context = useContext(MultilingualFormContext)
  if (context === undefined) {
    throw new Error('useMultilingualForm must be used within a MultilingualFormProvider')
  }
  return context
}

// Hook for optional context (won't throw if not within provider)
export function useOptionalMultilingualForm() {
  return useContext(MultilingualFormContext)
}